export const statusBGColorMap = {
  NEW: '#4A97FF2B',
  STAY_AUDIT: '#E687872B',
  PUBLISHED: '#33AE652B',
  OFFLINE: '#8080802B',
  ALREADY_AUDIT: '#26BFE32B',
  MODIFIED: '#E191052B',
  EDITING: '#E191052B',
};

export const statusFontColorMap = {
  NEW: '#1890FF',
  STAY_AUDIT: '#E68787',
  PUBLISHED: '#33AE65',
  OFFLINE: '#808080',
  ALREADY_AUDIT: '#26BFE3',
  MODIFIED: '#E19105',
  EDITING: '#E19105',
};

export const statusTextMap = {
  NEW: '未发布',
  STAY_AUDIT: '待审核',
  ALREADY_AUDIT: '已审核',
  PUBLISHED: '已发布',
  OFFLINE: '已下架',
  MODIFIED: '已修改',
  EDITING: '修改中',
};
